import { render, staticRenderFns } from "./CourseBanner.vue?vue&type=template&id=5a4a0cf4&scoped=true"
import script from "./CourseBanner.vue?vue&type=script&lang=js"
export * from "./CourseBanner.vue?vue&type=script&lang=js"
import style0 from "./CourseBanner.vue?vue&type=style&index=0&id=5a4a0cf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4a0cf4",
  null
  
)

export default component.exports